import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ServicesSection.css';

const ServicesSection = ({ isFullPage = false }) => {
  const { t } = useTranslation();

  const services = [
    {
      title: t('services.implementation.title'),
      description: t('services.implementation.description'),
      icon: 'MDG',
      iconBg: '#36c8ff',
      link: '/services/mdg-implementation'
    },
    {
      title: t('services.dataQuality.title'),
      description: t('services.dataQuality.description'),
      icon: 'DQM',
      iconBg: '#8b5cf6',
      link: '/services/data-quality'
    },
    {
      title: t('services.migration.title'),
      description: t('services.migration.description'),
      icon: 'DM',
      iconBg: '#10b981',
      link: '/services/data-migration'
    },
    {
      title: t('services.consulting.title'),
      description: t('services.consulting.description'),
      icon: 'ST',
      iconBg: '#ea580c',
      link: '/services/strategic-consulting'
    },
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        <div className="services-header">
          <h2>{t('services.title')}</h2>
          <p>{t('services.subtitle')}</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <Link key={index} to={service.link} className="service-card-link">
              <div className="service-card">
                <div className="service-header">
                  <div className={`service-icon service-icon-${index + 1}`} style={{ backgroundColor: service.iconBg }}>
                    {service.icon}
                  </div>
                  <h3>{service.title}</h3>
                </div>
                <p>{service.description}</p>
                <div className="service-learn-more">
                  <span>{t('services.learnMore')}</span>
                  <span className="arrow">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {!isFullPage && (
          <div className="services-cta">
            <Link to="/services" className="btn btn-primary">
              {t('services.viewAll')}
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
